"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchRoomService = void 0;
const tsyringe_1 = require("tsyringe");
const httpService_1 = require("../httpService/httpService");
const memory_cache_1 = __importDefault(require("memory-cache"));
const contractService_1 = require("../contractService/contractService");
const required_1 = require("../../../../helpers/required/required");
let FetchRoomService = class FetchRoomService {
    constructor(httpService, contractService) {
        this.httpService = httpService;
        this.contractService = contractService;
        this.memCache = new memory_cache_1.default.Cache();
        this.setCacheMethods = (parameters) => __awaiter(this, void 0, void 0, function* () {
            required_1.requiredDefined(parameters.get, 'get must be defined');
            required_1.requiredDefined(parameters.set, 'set must be defined');
            this._getCacheRoom = parameters.get;
            this._setCacheRoom = parameters.set;
            return this;
        });
        /**
         * Add to cache a room
         * @param roomId
         * @param {NFTROOM} content
         */
        this.addToCache = (roomId, content) => {
            this.memCache.put(roomId, Promise.resolve(content));
            if (this._setCacheRoom) {
                this._setCacheRoom({ roomId, content });
            }
        };
        this.rawFetchRoom = (roomId) => __awaiter(this, void 0, void 0, function* () {
            const tokenURI = yield this.contractService.erc721Contract().methods.tokenURI(roomId)
                .call().catch((e) => { console.error('error fetchingRoom', e); return undefined; });
            if (tokenURI === undefined) {
                return undefined;
            }
            return this.httpService.fetch(tokenURI);
        });
        /**
         * Fetch room.
         * If a room exist in custom cache, it will return custom cache.
         * Otherwise it returns a cached promise of the fetching room
         * @param {string} roomId
         * @returns {Promise<NFTROOM>}
         */
        this.fetchRoom = (roomId) => __awaiter(this, void 0, void 0, function* () {
            let nftRoom;
            if (this._getCacheRoom) {
                nftRoom = yield this._getCacheRoom(roomId);
                if (nftRoom) {
                    return nftRoom;
                }
            }
            nftRoom = this.memCache.get(roomId);
            if (!nftRoom) {
                const cacheTimeout = 30 * 1000;
                this.memCache.put(roomId, this.rawFetchRoom(roomId)
                    .then(d => {
                    if (typeof d !== 'object') {
                        throw new Error(`This nft ${roomId} is not a json.`);
                    }
                    if (this._setCacheRoom) {
                        this.memCache.del(roomId);
                        this._setCacheRoom({ roomId: roomId, content: d });
                    }
                    return d;
                })
                    .catch(e => {
                    console.error('fetchRoom error', e.toString());
                    this.memCache.del(roomId);
                }), cacheTimeout);
            }
            return this.memCache.get(roomId);
        });
    }
};
FetchRoomService = __decorate([
    tsyringe_1.scoped(tsyringe_1.Lifecycle.ContainerScoped),
    __metadata("design:paramtypes", [httpService_1.HttpService,
        contractService_1.ContractService])
], FetchRoomService);
exports.FetchRoomService = FetchRoomService;
//# sourceMappingURL=fetchRoomService.js.map